<template>
    <div>
        <b-table
            :fields="fields"
            :items="items"
            :class="['gk-table gk-table--responsive gk-table--striped gk-table--headed']"
            :busy="loading"
            :thead-class="items && items.length ? '': 'd-none'"
            show-empty
            table-busy>
            <template #empty="">
                <EmptyState>
                    <template v-slot:image>
                        <img src="/static/img/empty-states/empty-state-cost.png">
                    </template>
                    <template v-slot:title>
                        {{ $gettext('No data available') }}
                    </template>
                    <template v-slot:cta>
                    <GekkoButton 
                        :text="$gettext('Go to invoices')"
                        icon="fa-solid fa-file-lines"
                        :to="{ name: 'Invoices' }" 
                    />
                    </template>
                </EmptyState>
            </template>

            <template #cell()="data">
                <span v-if="data.field.key === 'text_label'" :style="[0, 3, 6].includes(data.index) ? 'font-weight: bold;' : ''">
                    {{ getLabelText(data.value) }}

                    <span v-if="data.index === 0">
                        <font-awesome-icon id="tooltip-net-income" class="tooltip-icon tooltip-icon--question" icon="fa-regular fa-circle-question" />
                        <b-tooltip :custom-class="'tooltip-padded'" target="tooltip-net-income" triggers="hover" container="#report-container">
                            <div class="tooltip-title">
                                {{ $gettext('Net Income') }}
                            </div>
                            <div class="tooltip-text">
                                {{ $gettext('All totals are excluding VAT.') }}
                            </div>
                        </b-tooltip>
                    </span>

                    <span v-if="data.index === 3">
                        <font-awesome-icon id="tooltip-unpaid-invoices" class="tooltip-icon tooltip-icon--question" icon="fa-regular fa-circle-question" />
                        <b-tooltip :custom-class="'tooltip-padded'" target="tooltip-unpaid-invoices" triggers="hover" container="#report-container">
                            <div class="tooltip-title">
                                {{ $gettext('Net Expenses') }}
                            </div>
                            <div class="tooltip-text">
                                {{ $gettext('All totals are excluding VAT.') }}
                            </div>
                        </b-tooltip>
                    </span>
                </span>

                <span v-else :style="[0, 3, 6].includes(data.index) ? 'font-weight: bold;' : ''">
                    €&nbsp;{{ Number(data.value).toFixed(2).replace(/\.?0+$/, '') }}
                </span>
            </template>
        </b-table>
    </div>
</template>

<script>
import EmptyState from "@/components/ui/EmptyState"
import GekkoButton from "@/components/GekkoButton"

export default {
    name: 'RevenueExpensesTable',
    components: {EmptyState, GekkoButton},
    props: {
        revenueData: {
            type: Array,
            default: () => []
        }
    },
    watch: {
        revenueData() {
            this.setData()
            this.loading = false
        }
    },
    data() {
        return {
            items: [],
            fields: [],
            loading: true
        }
    },
    methods: {
        setData() {
            const data = Array.isArray(this.revenueData) ? this.revenueData : []

            if (!data.length) {
                this.fields = []
                this.items = []
                return
            }

            const [firstRow, ...restRows] = data

            this.header = Array.isArray(firstRow) ? firstRow : []
            this.items = restRows

            this.fields = this.header.map(field => {
                if (field.length < 1) {
                    return { key: 'text_label', label: ''}
                }
                return { key: field, thClass: 'text-right', tdClass: 'text-right' }
            })

            this.items = this.items.map(row => {
                const item = {}
                this.header.forEach((field, index) => {
                    if (field.length < 1) {
                        item['text_label'] = row[index]
                    } else {
                        item[field] = row[index]
                    }
                })
                return item
            })
        },
        getLabelText(key) {
            switch (key) {
                case 'netincome':
                    return this.$gettext('Net Income')
                case 'income':
                    return this.$gettext('Paid Invoices')
                case 'unpaidincome':
                    return this.$gettext('Unpaid Invoices')
                case 'netexpenses':
                    return this.$gettext('Net Expenses')
                case 'expenses':
                    return this.$gettext('Paid Bills')
                case 'unpaidexpenses':
                    return this.$gettext('Unpaid Expenses')
                case 'margin':
                    return this.$gettext('Margin')
                default:
                    return key
            }
        }
    }
}
</script>